module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BlackSemiCnIt.ef313ff.woff";